import React, { useEffect, useState } from 'react'
import "../NotesPage/NotesPage.css"
import DynamicSVG from '../DynamicSVG/DynamicSVG'
import Modal from "../Modal/Modal"
import useModal from "../../hooks/useModal"
import NoteItem from './NoteItem/NoteItem'
import { NavLink } from 'react-router-dom'
import ToastList from '../ToastsList/ToastsList'
import useToast from '../../hooks/useToast'
import useDrawer from '../../hooks/useDrawer'
import Drawer from '../Drawer/Drawer'
import NoteHandler from '../../Database/handlers/NoteHandler'
import { INote, INoteFolder } from '../../types/interfaces'
import TopNavBar from '../TopNavBar/TopNavBar'
import useLocalStorage from '../../hooks/useLocalStorage'

export default function NotesPage() {
  const [isCreateFolderOpen, toggleCreateFolderDrawer] = useDrawer()
  const [isEditFolderOpen, toggleEditFolderDrawer] = useDrawer()
  const [Toasts, AddToast, DeleteToast] = useToast()
  const [state, setstate] = useState<{
    folders: INoteFolder[],
    notes: INote[],filteredNotes:INote[]
  }>({
    folders:[],notes:[],filteredNotes:[]
  })
  const noteHandler =new NoteHandler()
  const [project,setproject] = useLocalStorage("project",null)
  function handleCreateFolder(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const folderName = event.currentTarget.elements[0] as HTMLInputElement
    const folderColour = event.currentTarget.elements[1] as HTMLInputElement
    console.log(folderName.value)
    noteHandler.CreateFolder(folderName.value, folderColour.value,project.ProjectName).then(() => {
     
      noteHandler.FetchFolders(project.ProjectName).then((folders) => {

        setstate({...state,folders:folders})
      })
    })
    toggleCreateFolderDrawer()
    
  }
  function handleDeleteNote(filterKey:number){
    noteHandler.DeleteNote(filterKey).then(() => {
      noteHandler.FetchNotes(project.ProjectName).then((notes) => {
        setstate({...state,notes:notes,filteredNotes:notes})
      })
    })
  }
  function handleDeleteFolder(folderKey:number) {
    noteHandler.DeleteFolder(folderKey, false).then(() => {
      noteHandler.FetchFolders(project.ProjectName).then((folders) => {
        setstate({...state,folders:folders})
      })
    })
  }
  function FilterNotes(event:React.ChangeEvent<HTMLSelectElement>) {
    const eventValue = event.target.value
    if (eventValue !== "All Notes") {

      const filteredNotes = state.notes.slice().filter((note) => {
        return note.folder == eventValue
      })
      setstate({...state,filteredNotes:filteredNotes})
    } else {
      noteHandler.FetchNotes(project.ProjectName).then((notes) => {
        setstate({...state,filteredNotes:state.notes})
      })
    }
    
    
  }
  function FindFolder(folderTitle: string) {
    const defaultFolder: INoteFolder = {
      title: "All Notes", colour: "Purple",
      notes: [],project:project.ProjectName
    }
    let folder = state.folders.find((folder) => {
      return folder.title == folderTitle
    })
    return folder || defaultFolder
  }
  useEffect(() => {
    noteHandler.FetchNotes(project.ProjectName).then((notes) => {
      noteHandler.FetchFolders(project.ProjectName).then((folders) => {
        setstate({...state,folders:folders,notes:notes,filteredNotes:notes})
      })
    })
    
  }, [])
  
  return (
    <>
    <Drawer isOpen={isCreateFolderOpen} toggleDrawer={toggleCreateFolderDrawer}>
      <form onSubmit={handleCreateFolder}>
        <h3 className='Drawer-Title'>Create a folder</h3>
        <div className='Input-Container'>
          <label htmlFor='FolderName'>Folder Name:</label>
          <input id='FolderName' type="text" />
        </div>  
        <br/>
        <div className='Input-Container'>
          <label htmlFor='FolderColour'>Folder Colour:</label>
          <select id="FolderColour">
            <option>Red</option>
            <option>Orange</option>
            <option>Yellow</option>
            <option>Green</option>
            <option>Blue</option>
            <option>Purple</option>
          </select>
        </div>
        
        <button type='submit' >Submit</button>
      </form>
    </Drawer>
    <Drawer isOpen={isEditFolderOpen} toggleDrawer={toggleEditFolderDrawer}>
      <form onSubmit={handleCreateFolder}>
        <h3 className='Drawer-Title'>Edit folders</h3>
        <h5 className='Info-Msg'><DynamicSVG SvgName="Info-Icon"/>Notes in deleted folders won't be deleted</h5>
        <h4>Folders:</h4>
        <ul className='Drawer_FoldersListItem'>
          {
            state.folders.map((folder) => {
              
              return (
                <li key={folder.id || 0} value={folder.title}>
                  {folder.title}
                  <button type='button' onClick={()=>handleDeleteFolder(folder.id||0)}>Delete</button>
                </li>
              )
            })
          }
        </ul>
      
        
      </form>
    </Drawer>
    <div className='Notes-Page-Container Side-Content'>
      <TopNavBar OptionsMenuElements={[
        <NavLink  id='Create-Note-Btn' to={'/notes/edit/newNote'}>
          <DynamicSVG SvgName="Plus-Icon" />
          Create note
          </NavLink>,
        <button id='Create-Note-Folder-Btn' onClick={toggleCreateFolderDrawer}>
          <DynamicSVG SvgName="Plus-Icon" />
          Create folder
        </button>,
        <button id='Edit-Note-Folder-Btn' onClick={toggleEditFolderDrawer}>
          <DynamicSVG SvgName="Plus-Icon" />
          Edit folder
        </button>
      ]}>
        <div className='TopNav-Content'>
          <h2>{project.ProjectName}</h2>
        </div>
      </TopNavBar>
      <div className='Notes-FilterBar Input-Container'>
          <label htmlFor="filterNotes">Filter Notes</label>
          <select id="filterNotes" onChange={FilterNotes}>
            <option defaultChecked>All Notes</option>
            {
              
              state.folders.map((folder)=>{
                console.log(state.folders);
                return <option key={folder.id||0} className={folder.colour} value={folder.title}>{folder.title}</option>
              })
            }
          </select>
      </div>
      <div className='Notes-Container'>
        
        {
            state.filteredNotes.map((note) => {
            
              return <NoteItem
              id={note.id||0}
              key={note.id||0}
              folderData={FindFolder(note.folder)}
              title={note.title}
              description={note.description}
              content={note.content}
              date={note.date} 
              deleteCallback={handleDeleteNote}
              />
          })
        }
        
      </div>
      </div>
    </>
  )
}
